import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const names = {
    MERKGARANTIE: "Merkgarantie",
    HUISGARANTIE: "Huisgarantie",
    BOVAG: "BOVAG garantie"
};

export const GarantiesEnZekerhedenFilter = ({ condensed }) => {
    const garantieTypes = useFilter("garantietype");
    const garantieTypesCount = useCount("garantietype");
    const kilometerstandCorrectCount = useCount("kilometerstandCorrect");
    const onderhoudsboekjeAanwezigCount = useCount("onderhoudsboekjeAanwezig");
    const honderdprocentonderhoudenCount = useCount("honderdprocentonderhouden");
    const [garantieTypesValue, , onGarantieTypesChange] = useField("garantietypes");
    const [kilometerstandCorrectValue, , onKilometerstandCorrectChange] =
        useField("kilometerstandCorrect");
    const [onderhoudsboekjeAanwezigValue, , onOnderhoudsboekjeAanwezigChange] = useField(
        "onderhoudsboekjeAanwezig"
    );
    const [honderdprocentonderhoudenValue, , onHonderdprocentonderhoudenChange] = useField(
        "honderdprocentonderhouden"
    );

    const garantieTypeOptions =
        garantieTypes.map((option) => ({
            id: option,
            displayName: names[option],
            aantal: garantieTypesCount[option] || 0
        })) || [];

    const options = [
        ...garantieTypeOptions,
        {
            id: "true",
            displayName: "Nationale Autopas (NAP)",
            aantal: kilometerstandCorrectCount?.true || 0,
            value: kilometerstandCorrectValue || [],
            datalayerKey: "kilometerstandCorrect",
            onChange: (_, v) => onKilometerstandCorrectChange(v)
        },
        {
            id: "true",
            displayName: "Onderhoudsboekje aanwezig",
            aantal: onderhoudsboekjeAanwezigCount?.true || 0,
            value: onderhoudsboekjeAanwezigValue || [],
            datalayerKey: "onderhoudsboekjeAanwezig",
            onChange: (_, v) => onOnderhoudsboekjeAanwezigChange(v)
        },
        {
            id: "true",
            displayName: "Keurmerk 100% Onderhouden",
            aantal: honderdprocentonderhoudenCount?.true || 0,
            value: honderdprocentonderhoudenValue || [],
            datalayerKey: "honderdprocentonderhouden",
            onChange: (_, v) => onHonderdprocentonderhoudenChange(v)
        }
    ];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-garanties"
                options={options}
                value={garantieTypesValue || []}
                handleChange={(_, v) => onGarantieTypesChange(v)}
                columns={condensed ? 1 : 2}
                datalayerKey="garantietype"
                maxSize={0}
            />
        </Grid>
    );
};
